export const ANONYMOUS_CUSTOMER_ID = -1;
export const APPLICATION_NAME = 'shopping-bag-provider';

/** Identity server client ID for local (development-time) authentication. */
export const IDENTITY_CLIENT_ID = 'SPADev';
